define.alias("shared/helpers/format-number-to-locale-string", "settings/helpers/format-number-to-locale-string");